<template>
  <div id="email-quote-template">
    <!DOCTYPE html>
    <html lang="en">

    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>{{ vehicleDisplayName }}</title>
    </head>

    <body
      style="font-family: Arial, Helvetica, sans-serif; margin: 0; padding: 0; background-color: #f6f6f6; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">

      <table role="presentation" cellpadding="0" cellspacing="0" width="100%"
        style="max-width:700px; margin:20px auto; background-color:#ffffff; border-collapse:collapse;">
        <tr>
          <td>
            <table role="presentation" cellpadding="0" cellspacing="0" width="100%">
              <tr>
                <td width="10%" style="padding:10px; text-align:left;">
                  <img :src="websiteInfo.logoImage" alt="Best Honda Logo" style="max-width:100px;" />
                </td>
                <td width="90%" valign="middle" style="font-size:11px; color:#555555; text-align:right;">
                  <table role="presentation" cellpadding="0" cellspacing="0" width="100%">
                    <tr>
                      <td v-if="websiteInfo.salesNumber" style="padding: 0 4px;">&#9990; Sales:
                        {{ websiteInfo.salesNumber }}</td>
                      <td v-if="websiteInfo.serviceNumber" style="padding: 0 4px;">&#9990; Service:
                        {{ websiteInfo.serviceNumber }}</td>
                      <td v-if="websiteInfo.fullAddress" style="padding: 0 4px;">&#x26AC; {{ websiteInfo.fullAddress }}
                      </td>
                      <td v-if="websiteInfo.contactEmail" style="padding: 0 4px;">{{ websiteInfo.contactEmail }}</td>

                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td style="padding:15px; border-bottom:1px solid #eeeeee;">
            <table role="presentation" cellpadding="0" cellspacing="0" width="100%">
              <tr>
                <td width="50%" valign="top">
                  <p style="font-size:20px; font-weight:bold; color:#333333; margin:0 0 5px 0;">{{ vehicleDisplayName }}
                  </p>

                  <p style="font-size:14px; color:#555555; margin:0 0 10px 0;">
                  <table role="presentation" cellpadding="0" cellspacing="0" style="font-size:10px; margin:0;">
                    <tr>

                      <td style="padding:0 4px;" v-if="vehicleInfo.extColorHexCode || vehicleInfo.ext_Color_Generic">
                        <span style="width: 50px;display: inline-block;">Exterior:</span>
                        <span :style="getVehicleIntExteriorColorStyle(
                          vehicleInfo.extColorHexCode,
                          vehicleInfo.ext_Color_Generic
                        )" style=" width:10px; height:10px; border-radius:50%; display:inline-block;"></span>
                        {{ vehicleInfo.exteriorColor }}
                      </td>
                    </tr>
                    <tr>

                      <td style="padding:0 4px;" v-if="vehicleInfo.intColorHexCode || vehicleInfo.int_Color_Generic">
                        <span style="width: 50px;display: inline-block;">Interior: </span>
                        <span :style="getVehicleIntExteriorColorStyle(
                          vehicleInfo.intColorHexCode,
                          vehicleInfo.int_Color_Generic
                        )" style=" width:10px; height:10px;border-radius:50%;
                        display:inline-block;"></span>
                        <span>{{ vehicleInfo.interiorColor }}</span>
                      </td>

                    </tr>
                    <tr>
                      <td style="padding:0 4px;">
                        <p style="margin: 0;font-size: 10px !important;">VIN: <b>{{ vehicleInfo.vin }}</b></p>

                        <p style="margin: 0;font-size: 10px !important;">Model Code: <b>{{ vehicleInfo.modelNumber
                            }}</b>
                        </p>
                      </td>

                      <td style="padding:0 4px;">
                        <p style="margin: 0;font-size: 10px !important;"> Stock # <b>{{ vehicleInfo.stock }}</b></p>
                        <p style="margin: 0;font-size: 10px !important;">Model Code: <b>{{ vehicleInfo.modelNumber
                            }}</b>
                        </p>
                      </td>
                    </tr>
                  </table>
                  </p>

                  <div style="border:1px solid #eee; border-radius:8px; padding:10px; max-width:60%;"
                    v-if="msrpDetails && msrpDetails.length && msrpDetails.slice(0, -1).length">
                    <table role="presentation" cellpadding="0" cellspacing="0" width="100%"
                      style="font-size:10px; border-collapse:collapse;">
                      <tr v-for="(item, index) in msrpDetails.slice(0, -1)" :key="'main-' + index">
                        <td>{{ item.key }}</td>
                        <td v-if="item.value" style="text-align:right; font-weight:bold;">{{ item.value }}</td>
                      </tr>

                    </table>
                  </div>

                  <p v-if="msrpDetails && msrpDetails.length"
                    style="font-size:28px; font-weight:bold; color:#000000; margin:10px 0 0 0;">
                    <b v-if="msrpDetails[msrpDetails.length - 1].value">
                      {{ msrpDetails[msrpDetails.length - 1].value }}
                    </b>
                  </p>
                  <p style="font-size:9px; color:#555555;">Price includes destination and handling. Offer expires
                    10/31/2025.</p>
                </td>
                <td width="50%" align="right" valign="middle">
                  <img :src="vehicleInfo.vehicleImg" alt="" style="max-width:100%;" />
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr v-if="leaseGrouped && leaseGrouped.length">
          <td style="padding:15px 15px 10px 15px;">
            <p style="font-size:15px; font-weight:bold; color:#333333; margin:0 0 15px 0; text-align:center;">Leasing
              Options</p>
            <table role="presentation" cellpadding="0" cellspacing="0" width="100%">
              <tr v-for="(row, rowIndex) in leaseGrouped" :key="rowIndex">
                <td v-for="(item, index) in row" :key="index" width="32%" valign="top" style="padding-right:5px;">
                  <table role="presentation" cellpadding="0" cellspacing="0" width="100%"
                    style="border-radius:5px; padding:10px; text-align:center; margin-bottom:10px; box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px; border:1px solid #eee;">
                    <tr>
                      <td
                        style="font-size:10px; color:#000; background:#edecec; padding:5px; border-radius:10px; font-weight:700;">
                        {{ item.Term }} months</td>
                    </tr>
                    <tr>
                      <td style="height:10px; padding-top:5px; font-weight:bold;"></td>
                    </tr>
                    <tr>
                      <td style="font-size:20px; font-weight:bold; color:#000000; padding:5px 0;">{{ item.Payment }}
                      </td>
                    </tr>
                    <tr>
                      <td style="font-size:7px; color:#000; margin:0; font-weight:900; text-transform:capitalize;">per
                        month lease payment for {{ item.Term }} months</td>
                    </tr>
                    <tr v-if="item.MailDisclaimer">
                      <td style="font-size:9px; color:#555555; padding-top:5px;">{{
                        item.MailDisclaimer }}</td>
                    </tr>
                  </table>
                </td>

              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td style="font-size:9px; color:#aaaaaa; text-align:left; padding:0 20px 20px 20px;">
            Lease Details: 2025 Honda CR-V LX AWD CVT. Closed-end lease. Available to well-qualified lessees approved by
            Honda Financial Services. Not all lessees will qualify. Higher lease rates apply for lessees with lower
            credit
            ratings. Lessee responsible for maintenance, excessive wear/tear and 20¢/mile over 10,000 miles/year. Offer
            valid through 10/31/2025. Please see Best Honda for complete details.
          </td>
        </tr>

        <tr>
          <td style="border-bottom:1px solid #eeeeee;"></td>
        </tr>

        <tr v-if="financeGrouped && financeGrouped.length">
          <td style="padding:15px 15px 10px 15px;">
            <p style="font-size:15px; font-weight:bold; color:#333333; margin:0 0 15px 0; text-align:center;">Financing
              Options</p>
            <table role="presentation" cellpadding="0" cellspacing="0" width="100%">
              <tr v-for="(row, rowIndex) in financeGrouped" :key="rowIndex">
                <td v-for="(item, index) in row" :key="index" width="32%" valign="top" style="padding-right:5px;">
                  <table role="presentation" cellpadding="0" cellspacing="0" width="100%"
                    style="border-radius:5px; padding:10px; text-align:center; margin-bottom:10px; box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px; border:1px solid #eee;">
                    <tr>
                      <td
                        style="font-size:10px; color:#000; background:#edecec; padding:5px; border-radius:10px; font-weight:700;">
                        {{ item.Term }} months</td>
                    </tr>
                    <tr>
                      <td style="height:10px; padding-top:5px; font-weight:bold;"></td>
                    </tr>
                    <tr>
                      <td style="font-size:20px; font-weight:bold; color:#000000; padding:5px 0;">{{ item.Payment }}
                      </td>
                    </tr>
                    <tr>
                      <td style="font-size:7px; color:#000; margin:0; font-weight:900; text-transform:capitalize;">per
                        month lease payment for {{ item.Term }} months</td>
                    </tr>
                    <tr v-if="item.MailDisclaimer">
                      <td style="font-size:9px; color:#555555; padding-top:5px;">{{
                        item.MailDisclaimer }}</td>
                    </tr>
                  </table>
                </td>

              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td style="font-size:9px; color:#aaaaaa; text-align:left; padding:0 20px 20px 20px;">
            Finance Details: 2025 Honda CR-V LX AWD CVT. Financing subject to credit approval. Offer valid through
            10/31/2025. Please see Best Honda for complete details.
          </td>
        </tr>

        <tr>
          <td style="border-bottom:1px solid #eeeeee;"></td>
        </tr>


        <tr v-if="qualifiedData && qualifiedData.length">
          <td style="padding:15px 15px 10px 15px;">
            <p style="font-size:15px; font-weight:bold; color:#333333; margin:0 0 15px 0; text-align:center;">
              Incentivies
            </p>
            <table role="presentation" cellpadding="0" cellspacing="0" width="100%">
              <tr v-for="(row, rowIndex) in qualifiedDataGrouped" :key="rowIndex">
                <td v-for="(item, index) in row" :key="item.VIN" width="33%" valign="top" style="padding: 5px;">
                  <table role="presentation" cellpadding="0" cellspacing="0" width="100%"
                    style="border-radius:5px; padding:10px; text-align:center; box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px; border:1px solid #eee;">
                    <tr>
                      <td
                        style="font-size:10px; color:#000; background:#edecec; padding:5px; border-radius:10px; font-weight:700;">
                        {{ formatDate(item.StartDate) }} - {{ formatDate(item.ExpiryDate) }}
                      </td>
                    </tr>
                    <tr>
                      <td style="height:10px; padding-top:5px; font-weight:bold;">{{ item.NameDetailed }}</td>
                    </tr>
                    <tr>
                      <td style="font-size:20px; font-weight:bold; color:#000000; padding:5px 0;">${{ item.Amount }}
                      </td>
                    </tr>
                    <tr>
                      <td style="font-size:7px; font-weight:900; text-transform:capitalize;">{{ item.Type }}</td>
                    </tr>
                    <tr>
                      <td style="font-size:9px; color:#555; padding-top:5px;">{{ item.Disclaimer }}</td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>

      </table>
    </body>

    </html>
  </div>
</template>
<script>


export default {
  props: {
    vehicleInfo: {
      type: Object,
      required: false
    },
    msrpDetails: {
      type: Array,
      required: false
    },
    qualifiedData: {
      type: Array,
      required: false
    },
    paymentCollection: {
      type: Array,
      required: false
    },
  },
  data() {
    return {
      websiteInfo: {
        domain: window.domain || window.primaryDomain,
        fullAddress: window.fullAddress,
        salesNumber: window.salesNumber,
        serviceNumber: window.serviceNumber,
        contactEmail: window.contactEmail,
        logoImage: window.logoImage,
      }
    }
  },
  computed: {
    vehicleDisplayName() {
      if (!this.vehicleInfo) {
        return "";
      }
      const { year, make, model, trim } = this.vehicleInfo;
      return [year, make, model, trim].filter(Boolean).join(" ");
    },
    qualifiedDataGrouped() {
      if (!this.qualifiedData || !this.qualifiedData.length) {
        return [];
      }
      const chunkSize = 3;
      return this.chunkArray(this.qualifiedData, chunkSize);
    },
    leaseGrouped() {
      if (!this.paymentCollection || !this.paymentCollection.length) {
        return [];
      }
      const leaseDetails = this.paymentCollection.filter(item => item.OfferType === 'Closed End');
      const chunkSize = 3;
      return this.chunkArray(leaseDetails, chunkSize);
    },
    financeGrouped() {
      if (!this.paymentCollection || !this.paymentCollection.length) {
        return [];
      }
      const financeDetails = this.paymentCollection.filter(item => item.OfferType === 'Loan');
      const chunkSize = 3;
      return this.chunkArray(financeDetails, chunkSize);
    },
  },
  methods: {
    getVehicleIntExteriorColorStyle(colorHexCode, colorGeneric) {
      if (colorHexCode === "" && colorGeneric === "") {
        return {
          "background-color": "transparent",
          border: "1px solid #ccc",
        };
      }

      const color = colorHexCode ? `#${colorHexCode}` : colorGeneric;
      return { "background-color": `${color} !important`, "border-color": `${color} !important` };
    },
    chunkArray(array, size) {
      const result = [];
      for (let i = 0; i < array.length; i += size) {
        result.push(array.slice(i, i + size));
      }
      return result;
    },
    formatDate(dateStr) {
      const date = new Date(dateStr)
      return date.toLocaleDateString()
    }
  },
  mounted() {
    console.log("Mounted AiEmailTemplate with vehicleInfo:", this.vehicleInfoData);
  }
}
</script>
<style lang="">

</style>
